// extracted by css-extract-rspack-plugin
export default {"cls1":"mentions_milestone_ping-cls1_3BZ","cls2":"mentions_milestone_ping-cls2_6CK mentions_milestone_ping-cls1_3BZ"};